/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwa_Install_Profile_BodyInputs */

const cs_pwa_install_profile_body = /** @type {(inputs: Pwa_Install_Profile_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spouštějte Cerebrio jako nativní aplikaci z plochy nebo domovské obrazovky.`)
};

const en_pwa_install_profile_body = /** @type {(inputs: Pwa_Install_Profile_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Cerebrio like a native app from your home screen or desktop.`)
};

/**
* | output |
* | --- |
* | "Open Cerebrio like a native app from your home screen or desktop." |
*
* @param {Pwa_Install_Profile_BodyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pwa_install_profile_body = /** @type {((inputs?: Pwa_Install_Profile_BodyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwa_Install_Profile_BodyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pwa_install_profile_body(inputs)
	return cs_pwa_install_profile_body(inputs)
});